module.exports = __webpack_public_path__ + "img/ico_biaoqianbaoshi.59a33334.png";